<script lang="ts">import shape2 from "./images/background/shape-bottom.svg";
import shape from "./images/background/shape-top.svg";
import star from "./images/background/star.svg";
import star2 from "./images/background/star2.svg";
import star3 from "./images/background/star3.svg";
import star4 from "./images/background/star4.svg";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { generateStars, genTinyStars } from "./utils";
export let starQuantity = 70;
export let small = false;
export let medium = true;
export let rounded = false;
export let roundedXl = false;
export let rounded2xl = false;
export let roundedTop = false;
export let noFigures = false;
export let maxSizeStar = undefined;
export let zIndex = undefined;
export let noBackgroundColor = false;
export let input = false;
export let withAnimation = false;
export let noGradient = false;
export let customStyle = "";
export let blueGradient = false;
/** Full-site root layout: same decorative base color as theme; no stars, figures, or gradient blobs. */
export let shellLayout = false;
/** Sidebar/dropdown embed: flat `--color-background-900` only; skips decorative ornaments and global solid/gradient-stars layers. */
export let embedSurface = false;
const tinyStars = genTinyStars();
$: effectiveStarQuantity = shellLayout ? 0 : starQuantity;
$: effectiveNoFigures = shellLayout || noFigures;
$: effectiveMedium = shellLayout ? true : medium;
$: effectiveSmall = shellLayout ? false : small;
$: effectiveNoGradient = shellLayout ? true : noGradient;
$: effectiveBlueGradient = shellLayout ? false : blueGradient;
$: effectiveWithAnimation = shellLayout ? false : withAnimation;
$: effectiveMaxSizeStar = shellLayout ? undefined : maxSizeStar;
$: stars = generateStars(effectiveStarQuantity, input, effectiveMaxSizeStar);
$: useSolid = $stateUi.background.backgroundStyle === "solid";
$: useGradientStars = $stateUi.background.backgroundStyle === "gradient-stars";
$: useDecorative = $stateUi.background.backgroundStyle === "decorative";
$: showDecorativeLayer = useDecorative && !embedSurface;
$: showSolidOrStarsLayer = (useSolid || useGradientStars) && !embedSurface;
$: showTopLight = useGradientStars && !embedSurface;
</script>

<div
	class="background"
	class:rounded-bg={rounded && !roundedTop}
	class:rounded-bg-xl={roundedXl}
	class:rounded-bg-2xl={rounded2xl}
	class:rounded-t-bg={roundedTop}
	class:no-bg={noBackgroundColor}
	class:has-bg={!noBackgroundColor}
	style="z-index: {zIndex || -1}; {customStyle}"
>
	{#if showDecorativeLayer}
		{#if !effectiveNoFigures}
			<img
				src={shape}
				class={effectiveSmall
					? 'shape-top-small'
					: effectiveMedium
						? 'shape-top-medium'
						: 'shape-top'}
				alt={$t(Verbiage.shape_top_alt, 'alts')}
			/>
			<img
				src={shape2}
				class={effectiveSmall
					? 'shape-bottom-small'
					: effectiveMedium
						? 'shape-bottom-medium'
						: 'shape-bottom'}
				alt={$t(Verbiage.shape_bottom_alt, 'alts')}
			/>
		{/if}
		{#each stars as { size, left, top, starType, animationDuration, animationDelay }, i}
			<img
				class={`star ${input || !effectiveWithAnimation ? 'no-animation' : ''}`}
				src={starType === 1 ? star : starType === 2 ? star2 : starType === 3 ? star3 : star4}
				style="width: {size}px; height: {size}px; position: absolute; left: {left}%; top: {top}%; animation-duration: {animationDuration}s; animation-delay: {animationDelay}s; {effectiveBlueGradient
					? 'z-index: 200!important;'
					: ''}"
				alt={$t(Verbiage.star_alt, 'alts')}
			/>
		{/each}
		{#if !effectiveNoGradient}
			<div class="gradient-container">
				{#if effectiveBlueGradient}
					<div
						class:gradient={!effectiveBlueGradient}
						class:blue-gradient={effectiveBlueGradient}
						style={`${effectiveBlueGradient ? ($isMobile ? 'transform: translateX(3%) translateY(-352px); width: 10000%' : 'transform: translateX(calc(100vw - 130%)) translateY(-352px); width: 71vw;') : 'margin-top: -350px; transform: translateX(150%);'}`}
					></div>
				{:else}
					<div
						class:gradient={!effectiveBlueGradient}
						class:blue-gradient={effectiveBlueGradient}
						style={`${effectiveBlueGradient ? ($isMobile ? 'transform: translateX(3%) translateY(-352px); width: 10000%' : 'transform: translateX(calc(100vw - 130%)) translateY(-352px); width: 71vw;') : 'margin-top: -350px; transform: translateX(150%);'}`}
					></div>
					<div
						class:gradient={!effectiveBlueGradient}
						class:blue-gradient={effectiveBlueGradient}
						style="margin-top: 1150px; transform: translateX(100%); width: 1500px;"
					></div>
					<div
						class:gradient={!effectiveBlueGradient}
						class:blue-gradient={effectiveBlueGradient}
						style="margin-top: 2650px; transform: translateX(100%); width: 1500px"
					></div>
					<div
						class:gradient={!effectiveBlueGradient}
						class:blue-gradient={effectiveBlueGradient}
						style="margin-top: 4150px; transform: translateX(100%); width: 1500px;"
					></div>
				{/if}
			</div>
		{/if}
	{/if}
	{#if showSolidOrStarsLayer}
		<div class="background-solid" class:background-gradient-stars={useGradientStars}>
			{#if useGradientStars}
				<img
					src={cfgToThemeCdnPath(`/background/star.svg`)}
					class="bg-star bg-star-top"
					alt={$t(Verbiage.shape_top_alt, 'alts')}
				/>
				<!-- <img
					src={cfgToThemeCdnPath(`/background/star.svg`)}
					class="bg-star bg-star-bottom"
					alt={$t(Verbiage.shape_bottom_alt, 'alts')}
				/> -->
				<img
					src={cfgToThemeCdnPath(`/background/star.svg`)}
					class="bg-star bg-star-right"
					alt={$t(Verbiage.shape_bottom_alt, 'alts')}
				/>
				{#each tinyStars as s}
					<img
						src={cfgToThemeCdnPath(`/background/star.svg`)}
						class="tiny-star"
						alt={$t(Verbiage.star_alt, 'alts')}
						style="left:{s.x}%; top:{s.y}%; width:{s.size}px; height:{s.size}px;"
					/>
				{/each}
			{/if}
		</div>
	{/if}
	{#if showTopLight}
		<div class="top-light" />
	{/if}
</div>

<style>
	.background {
		position: absolute;
		inset: 0px;
		height: 100%;
		width: 100%;
		overflow: hidden;
}

	.has-bg {
		background-color: var(--color-background-900);
}

	.no-bg {
		background-image: none;
}

	.rounded-bg {
		border-radius: 0.5rem;
}

	.rounded-bg-xl {
		border-radius: 0.75rem;
}

	.rounded-bg-2xl {
		border-radius: 1rem;
}

	.rounded-t-bg {
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
}

	.shape-top {
		position: absolute;
		top: 0px;
		right: 0px;
}

	.shape-top-medium {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 30rem;
}

	.shape-top-small {
		position: absolute;
		top: -12rem;
		left: 9rem;
		width: 24rem;
		transform: rotate(270deg);
}

	.shape-bottom {
		position: absolute;
		bottom: 0px;
		left: 0px;
}

	.shape-bottom-medium {
		position: absolute;
		bottom: 0px;
		left: 0px;
		width: 30rem;
}

	.shape-bottom-small {
		position: absolute;
		bottom: -9rem;
		right: 2rem;
		width: 24rem;
		transform: rotate(270deg);
}

	.star {
		animation-name: parallax;
		animation-timing-function: linear;
		animation-iteration-count: infinite;
		will-change: transform; /* Optimizes animations */
	}

	.no-animation {
		animation-name: none;
		animation-timing-function: none;
		animation-iteration-count: none;
		will-change: none;
	}

	.gradient-container {
		position: relative;
		left: 0px;
		right: 0px;
		top: 0px;
		display: flex;
		height: 100%;
		width: 100%;
		justify-content: center;
		overflow: hidden;
}

	.gradient {
		height: 700px;
		width: 1500px;
		border-radius: 9999px;
		background-color: var(--color-neutral-500);
		opacity: 0.7;
		--tw-blur: blur(100px);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

	.blue-gradient {
		height: 111vh;
		border-radius: 100%;
		opacity: 1;
		--tw-blur: blur(100px);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

	@media (min-width: 1024px) {

		.blue-gradient {
				--tw-blur: blur(220px);
				filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
		}
}

	.blue-gradient {
		background: var(--color-secondary-500) !important;
	}

	.background-solid {
		position: absolute;
		inset: 0px;
		height: 100%;
		width: 100%;
		background-color: var(--color-background-500);
}

	.background-gradient-stars {
		background: linear-gradient(
			180deg,
			var(--color-background-900) 0%,
			var(--color-background-500) 500%
		);
	}

	.bg-star {
		position: absolute;
		left: 0px;
		height: 85%;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

	.bg-star-top {
		top: 57%;
}

	.bg-star-bottom {
		top: calc(100vh + 70%);
	}

	.bg-star-right {
		right: 0px;
		left: auto;
		height: 10%;
		--tw-translate-x: 50%;
		--tw-rotate: 180deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		top: -5%;
}

	.tiny-star {
		pointer-events: none;
		position: absolute;
		opacity: 0.8;
		z-index: 0;
}

	@keyframes parallax {
		0% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-50px);
		}
	}

	.top-light {
		position: absolute;
		top: -400px;
		left: 50%;
		height: 600px;
		width: 200%;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		opacity: 0.8;
		pointer-events: none;
		z-index: 1;
		background: radial-gradient(
			ellipse at center,
			var(--color-primary-300) 0%,
			rgba(0, 0, 0, 0) 72%
		);
}

	@media (min-width: 1024px) {
		.top-light {
				top: -300px;
				height: 600px;
				width: 250%;
				opacity: 0.7;
			background: radial-gradient(
				ellipse at center,
				var(--color-primary-300) 0%,
				rgba(0, 0, 0, 0) 65%
			);
		}
	}
</style>
